import React from 'react';
import './SevenSegmentDisplay.css';

const SevenSegmentDisplay = ({ value, label }) => {
  // Round the value to the nearest integer
  const roundedValue = Math.round(parseFloat(value)).toString();
  
  // Convert the rounded value to an array of digits
  const digits = roundedValue.split('').map(Number);
  
  // Pad the digits to always have at least 5 digits
  const paddedDigits = Array(Math.max(5 - digits.length, 0)).fill(null).concat(digits);

  const renderDigit = (digit, key) => (
    <div key={key} className={`digit ${digit !== null ? `digit-${digit}` : 'digit-blank'}`}>
      <div className="segment a"></div>
      <div className="segment b"></div>
      <div className="segment c"></div>
      <div className="segment d"></div>
      <div className="segment e"></div>
      <div className="segment f"></div>
      <div className="segment g"></div>
    </div>
  );

  return (
    <div className="display-container">
      <div className="label">{label}</div>
      <div className="seven-segment-display">
        {paddedDigits.map((digit, index) => renderDigit(digit, `int-${index}`))}
      </div>
    </div>
  );
};

export default SevenSegmentDisplay;